export const REPORT_TYPES = {
  ANNEX_IV: 'Annex IV',
  FORM_PF: 'Form PF',
  CUSTOM: 'Custom',
  CONVERSION: 'Conversion'
};
export const reportTypesList = [
  {
    key: REPORT_TYPES.ANNEX_IV,
    title: 'Annex IV',
    description: 'EU regulatory report for AIFMs under AIFMD'
  },
  {
    key: REPORT_TYPES.FORM_PF,
    title: 'Form PF',
    description: 'US SEC report for private fund advisers'
  },
  {
    key: REPORT_TYPES.CUSTOM,
    title: 'Custom',
    description: 'Flexible report based on your own data'
  },
  {
    key: REPORT_TYPES.CONVERSION,
    title: 'Conversion',
    description: 'Seamlessly adapt reports for cross-use'
  }
];

export const REPORT_NAMINGS = {
  FUND: {
    [REPORT_TYPES.ANNEX_IV]: 'AIF',
    [REPORT_TYPES.CONVERSION]: 'AIF',
    [REPORT_TYPES.FORM_PF]: 'Fund',
    [REPORT_TYPES.CUSTOM]: 'Asset'
  },
  PROJECT: {
    [REPORT_TYPES.ANNEX_IV]: 'AIFM',
    [REPORT_TYPES.CONVERSION]: 'AIFM',
    [REPORT_TYPES.FORM_PF]: 'Adviser',
    [REPORT_TYPES.CUSTOM]: 'Project'
  },
  JURISDICTION: {
    [REPORT_TYPES.ANNEX_IV]: 'Jurisdiction',
    [REPORT_TYPES.CONVERSION]: 'Jurisdiction',
    [REPORT_TYPES.FORM_PF]: 'Fund Info',
    [REPORT_TYPES.CUSTOM]: 'Jurisdiction'
  }
};
